import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/epo/externallocations';

export default new class EpoExternallocationModel {

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, {id: id}));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(force = false) {    
      return new Promise((resolve, reject) => {
        if (!localStorage.getItem('dataset_epo_externallocations') || force) {
          axios.get(BASE, {
            params: {
              access_token: UserModel.getAccessToken()
            }
          })
          .then((response) => {
            localStorage.setItem('dataset_epo_externallocations', JSON.stringify(response.data));
            resolve(response.data);          
          })
          .catch((error) => {
            reject(error);
          });
        } else {
          resolve(JSON.parse(localStorage.getItem('dataset_epo_externallocations'))); 
        }
      });    
  }

}


// WEBPACK FOOTER //
// ./src/components/EpoExternallocationModel.js